import { Login as LoginContainer } from "../containers";
import React, { useState, useEffect } from "react";
import firebase from "../lib/fire";
import { useHistory, useLocation } from "react-router";
import secureLocalStorage from "react-secure-storage";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [hasAccount, setHasAccount] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const from = location.state?.from || "/app/main"; // fallback si no viene de un shared

  const clearInputs = () => {
    setEmail("");
    setPassword("");
  };

  const clearErrors = () => {
    setEmailError("");
    setPasswordError("");
  };

  const handleLogin = () => {
    clearErrors();
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch((err) => {
        switch (err.code) {
          case "auth/invalid-email":
          case "auth/user-disabled":
          case "auth/user-not-found":
            setEmailError("User error try again");
            break;
          default:
            break;
          case "auth/wrong-password":
            setPasswordError("Passwor error try again");
            break;
        }
      });
    sessionStorage.setItem("userAuth", true);
    secureLocalStorage.setItem("userAuth", {
      mail: email,
      password: password,
    });
  };

  const authListener = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        sessionStorage.setItem("userAuth", true);
        try {
          const data = firebase
            .database()
            .ref("/users/0/" + user.uid)
            .once("value")
            .then((snapshot) => {
              var username = snapshot.val() || "Anonymous";
              secureLocalStorage.setItem("userId", user.uid);
              sessionStorage.setItem("user", JSON.stringify(username));
            })
            .then((snapshot) => {
              clearInputs();

              history.replace(from);
            });
        } catch (error) {
          console.error("este es mi error", error);
        }
      }
    });
  };

  useEffect(() => {
    authListener();
  }, []);

  return (
    <>
      <LoginContainer
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        handleLogin={handleLogin}
        hasAccount={hasAccount}
        setHasAccount={setHasAccount}
        emailError={emailError}
        passwordError={passwordError}
        from={from}
      />
    </>
  );
}
